module.exports = __webpack_public_path__ + "static/media/background.4d55f251.jpg";